module.exports = __webpack_public_path__ + "static/media/creation.799cca78.png";